import { Component, EventEmitter, OnInit } from '@angular/core';
import { WorkOrder } from 'app/models2/maintenance/work-order';
import { NotificationsService } from 'app/services/notifications.service';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { HeaderFilters, LocalStorageService, MenuBreadCrumb, params, TableColumns, TableConfiguration } from 'brainloper-ui';

@Component({
  selector: 'app-maintenance-orders-dispatch',
  templateUrl: './maintenance-orders-dispatch.component.html',
  styleUrls: ['./maintenance-orders-dispatch.component.scss']
})
export class MaintenanceOrdersDispatchComponent implements OnInit {

  public urlTablaOT: string = `${EndpointDictionary.WorkOrder.WORK_ORDER_TABLE}`
  private urlComboEquipo : string = `${EndpointDictionary.Equipment.EQUIPMENT_COMBO}`

  public menuBreadCrumb:Array<MenuBreadCrumb> = [
    {
      name:"Inicio",
      router:'/inicio',
    },
    {
    name:"Despachar Recursos",
    current:true
  }]

  public params: params [] = [{ id: 'equipmentId', value: '0' }, { id: 'active', value: '1' }, { id: 'authorized', value: '1' }, { id: 'readyResources', value: '0' }]


  public dataOT: WorkOrder[] = []
  public recargarTablaOT = new EventEmitter<any>()
  public columnasOT: TableColumns<WorkOrder>[] = [
    {
      ID: 'consecutive',
      label: '#',
      type: 'text',
      style: {
        textAlign: 'center',
        width: '80px',
        movil: 'no-movil'
      },
    },
    {
      ID: 'code',
      label: 'Código',
      type: 'text',
      style: {
        textAlign: 'center'
      },
    },
    {
      ID: 'equipmentBrand',
      label: 'Marca Equipo',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },
    },
    {
      ID: 'component',
      label: 'Componente',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },
    },
    {
      ID: 'description',
      label: 'Descripción',
      type: 'text',
      style: {
        textAlign: 'center'
      },
    },
    {
      ID: 'executionDate',
      label: 'Fecha',
      type: 'fecha',
      style: {
        textAlign: 'center'
      },
    },
    {
      ID:'authorizes',
      label: 'Autoriza',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },
    },
    {
      ID: 'invoiceReference',
      label: 'Ref. Factura',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },
    },
    {
      ID:'readyResources',
      label: 'Recursos Listos',
      type: 'boolean',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },
    }
  ]
  public configurationOT: TableConfiguration = {
    edit: true,
    delete: true,
    selectable: true,
    addPer: true,
    editPer: true,
    primaryKey: 'id',
    print: true,
    packOff:true,    
    addComment: true,
    view: true,

  }

  headerFilters: Array<HeaderFilters> = [
    {
      tN: "equipos",
      labelFilter:"Equipo",
      urlData: this.urlComboEquipo,
      visibleField:"code",
      primaryKey:"id",
      type:"select",
      value:""
    },
    {
      tN: "ordenes_trabajo",
      visibleField:"fecha_ejecucion",
      labelFilter:"Fecha Ejecución",
      type:"date",
      value:""
    },
    {
      tN: "ordenes_trabajo",
      visibleField:"fecha_ejecucion",
      labelFilter:"Fecha Ejecución Entre",
      type:"dateRange",
      value:""
    }
  ]

  constructor(
    private storage : LocalStorageService,
    public notificationService: NotificationsService,
    ) { }

  ngOnInit(): void {
  }

}
